window.addEventListener("DOMContentLoaded", function() {
   window.onscroll = function (){
     var myFade = document.getElementsByClassName("fadein");
     for(var i = 0; i < myFade.length; i++){
       var targetElement = myFade[i].getBoundingClientRect(); //ターゲット要素の高さ
       var scroll = document.documentElement.scrollTop || document.body.scrollTop;  //スクロール
       var windowHeight = window.innerHeight;  //ウィンドウの高さ
       if (scroll > scroll + targetElement.top - windowHeight + 100){
         myFade[i].style.opacity = "1";
         myFade[i].style.transform = "translateY(0)";
       }
     }
   }
}, false);




// // 文字列変更
// document.addEventListener("DOMContentLoaded", function() {
//     // 文字列が "Write a Review" の全ての要素を取得
//     var elements = document.querySelectorAll(":contains('Write a Review')");

//     elements.forEach(function(element) {
//         // 文字列を "レビューを書く" に変更
//         element.textContent = element.textContent.replace("Write a Review", "レビューを書く");
//     });
// });

// // アコーディオン
// $(function () {
//   // タイトルをクリックすると
//   $(".js-accordion-title").on("click", function () {
//     // クリックした次の要素を開閉
//     $(this).next().slideToggle(300);
//     // タイトルにopenクラスを付け外しして矢印の向きを変更
//     $(this).toggleClass("open", 300);
//   });
// });